import * as Yup from "yup";

export const fileUploadSchema = Yup.object({
  base64StringWithMeta: Yup.string().optional().strip(),
})
  .optional()
  .nullable()
  .default(undefined);
